/* eslint camelcase: 0 */
import { getBackVersion } from '../../config';
import { DetailedTransactionSnapshot } from '../../models/Banking';
import api from '../api';

const createWithdrawalRequest = (
    externalAccountId: string,
    withdrawalId: string,
    amount: number,
    password: string
): Promise<DetailedTransactionSnapshot> =>
    api.request<DetailedTransactionSnapshot>({
        action: 'BANKING_WITHDRAWAL',
        method: 'POST',
        url: `${getBackVersion()}/banking/withdrawal`,
        data: {
            id: withdrawalId,
            account_password: password,
            amount: amount,
            external_account_id: externalAccountId,
        },
    });

export { createWithdrawalRequest };
